import { useProfileAdapter, type ProfilePage } from "adapters/profile";
import { IFrame } from "components/atoms/IFrame";

type ProfileIframeProps = {
  page?: ProfilePage;
};

const ProfileIframe = ({ page = "profile" }: ProfileIframeProps) => {
  const { basePath, ref, src, title } = useProfileAdapter({ page });
  return (
    <IFrame basePath={basePath} ref={ref} title={title} src={src}></IFrame>
  );
};

export { ProfileIframe };
